module.exports = __webpack_public_path__ + "assets/34e5be9ac54417ca5a071a1d2282ba4c.png";